<template>
  <LayoutDefault
    isShowHeader
    title="Баннер на главной странице"
    isShowFooter
    customFooter
    visibleClose
  >
    <div class="banner">
      <div class="banner__list">
        <draggable
          v-model="bannersData"
          class="banner__list-item"
          @change="moveBanners"
        >
          <template #item="{element}">
            <BannerUploaderItem
              @delete="deleteBanner(element.Id)"
              :urlBanner="element?.BannerFiles[0]?.FilePath"
              @click="getCurrentBanner(element)"
              :active="element.Id === currentId"
            />
          </template>
        </draggable>
      </div>
      <div class="adder">
        <BaseBtnNew
          name="Добавить фото"
          @clickBtn="openCloseLoader(true)"
        >
        <addImgIcon/>
        </BaseBtnNew>
      </div>

      <div class="banner__preview">
        <BannerUploaderItem
          :title="title"
          :description="description"
          :visibleDescription="visibleDescriptionPrewiew"
          bigPicture
          :urlBanner="currentBanner?.BannerFiles?.[0]?.FilePath"
        />
      </div>

      <div class="banner__editor">
        <div class="banner__editor-item">
          <p>Заголовок:</p>
          <InputText
            v-model="title"
            @input="showDescriptionPrewiew"
            type="text"
            placeholder="Введите заголовок баннера"
            :disabled="!currentBanner"
          />
        </div>
        <div class="banner__editor-item">
          <p>Краткое описание:</p>
          <Textarea
            v-model="description"
            @input="showDescriptionPrewiew"
            rows="1"
            cols="30"
            placeholder="Введите краткое описание"
            :auto-resize="true"
            :disabled="!currentBanner"
          />
        </div>
        <div class="banner__editor-item">
          <p>Ссылка:</p>
          <InputText
            v-model="link"
            @input="showDescriptionPrewiew"
            type="text"
            placeholder="Добавьте ссылку"
            :disabled="!currentBanner"
          />
        </div>
      </div>
    </div>

    <BaseModalWindow
      @closeModal="clearLoadBanners"
      v-if="showLoaderBanners"
      title="Загрузка изображения"
    >
      <div class="image-uploader" v-if="!loaderVideo">
        <div class="image-uploader__item">
          <p class="image-uploader__item-name">Декстоп (1920x477 px)</p>
          <div class="card flex justify-content-center">
            <FileUpload
              mode="basic"
              name="files[]"
              accept="image/*"
              :url="`${envUrlBase}/api/Banners/LoadBanner/1`" @before-send="authToken" :auto="false" chooseLabel="Добавить фото"
              withCredentials
            />
          </div>
        </div>

        <div class="image-uploader__item">
          <p class="image-uploader__item-name">Планшет (вертикальная версия, 1200x356  px)</p>
          <div class="card flex justify-content-center">
            <FileUpload
              mode="basic"
              name="files[]"
              :url="`${envUrlBase}/api/Banners/LoadBanner/2`" accept="image/*"
              @before-send="authToken"
              :auto="false"
              chooseLabel="Добавить фото"
              withCredentials
            />
          </div>
        </div>

        <div class="image-uploader__item">
          <p class="image-uploader__item-name">Планшет (горизонтальная версия, 960x356 px)</p>
          <div class="card flex justify-content-center">
            <FileUpload
              mode="basic"
              name="files[]"
              :url="`${envUrlBase}/api/Banners/LoadBanner/3`" accept="image/*"
              @before-send="authToken"
              :auto="false"
              chooseLabel="Добавить фото"
              withCredentials
            />
          </div>
        </div>

        <div class="image-uploader__item">
          <p class="image-uploader__item-name">Мобильная версия (вертикальная версия, 640x400 px)</p>
          <div class="card flex justify-content-center">
            <FileUpload
              mode="basic"
              name="files[]"
              :url="`${envUrlBase}/api/Banners/LoadBanner/4`" accept="image/*"
              @before-send="authToken"
              :auto="false"
              chooseLabel="Добавить фото"
              withCredentials
            />
          </div>
        </div>

        <div class="image-uploader__item">
          <p class="image-uploader__item-name">Мобильная версия (горизонтальная версия, 480x560 px)</p>
          <div class="card flex justify-content-center">
            <FileUpload
              mode="basic"
              name="files[]"
              :url="`${envUrlBase}/api/Banners/LoadBanner/5`" accept="image/*"
              @before-send="authToken"
              :auto="false"
              chooseLabel="Добавить фото"
              withCredentials
            />
          </div>
        </div>
        <div class="image-uploader__buttons">
          <BaseBtnNew
            name="Сохранить"
            @clickBtn="saveBanners"
          >
          <SaveIconNew/>
          </BaseBtnNew>

          <BaseBtnNew
            red
            name="Отменить"
            @clickBtn="clearLoadBanners"
          >
          <CancelIcon/>
          </BaseBtnNew>
        </div>
      </div>
      <div class="video-uploader" v-if="loaderVideo">
        <InputText
          type="text"
          placeholder="Ссылка"
        />
        <div class="video-uploader__buttons">
          <BaseBtn
            text="Сохранить"
          />
          <BaseBtn
            text="Отменить"
          />
        </div>
      </div>
    </BaseModalWindow>
    <template #customFooter>
      <div class="buttons">
        <BaseBtnNew
          name="Сохранить"
          @clickBtn="saveForms"
        >
          <SaveIconNew/>
        </BaseBtnNew>
        <BaseBtnNew
          red
          name="Отменить"
          @clickBtn="closeBannersEditor"
        >
        <CancelIcon/>
        </BaseBtnNew>
      </div>
    </template>
  </LayoutDefault>
</template>

<script>
import { ref, computed, onMounted, watch } from 'vue'
import { useStore } from 'vuex'

import router from '@/router'

import draggable from 'vuedraggable'

import BaseModalWindow from '@/components/modals/BaseModalWindow'
import LayoutDefault from '@/layout/LayoutDefault'
import BannerUploaderItem from '@/components/elements/BannerUploaderItem'

import BaseBtnNew from '@/components/ui/BaseBtnNew'
import addImgIcon from '@/components/icons/addImgIcon'
import CancelIcon from '@/components/icons/CancelIcon.vue'
import SaveIconNew from '@/components/icons/SaveIconNew.vue'

import InputText from 'primevue/inputtext'
import Textarea from 'primevue/textarea'
import FileUpload from 'primevue/fileupload'

export default {
  name: 'BannerEditorView',
  components: {
    draggable,
    LayoutDefault,
    BannerUploaderItem,
    BaseBtnNew,
    addImgIcon,
    CancelIcon,
    SaveIconNew,
    InputText,
    Textarea,
    BaseModalWindow,
    FileUpload
  },
  props: {
  },
  setup () {
    const store = useStore()
    const currentBanner = ref(null)
    const currentId = ref(0)
    const title = ref('')
    const description = ref('')
    const link = ref('')
    const visibleDescriptionPrewiew = ref(false)
    const visibleItems = ref(false)
    const loaderVideo = ref(false)
    const envUrlBase = process.env.VUE_APP_URL_BASE

    onMounted(() => {
      store.dispatch('setMainBannersData')
    })

    watch(currentBanner, (newValue) => {
      if (newValue.Description !== '' || newValue.Header) {
        visibleDescriptionPrewiew.value = true
      } else {
        visibleDescriptionPrewiew.value = false
      }
    })

    const bannersData = computed(() => {
      return store.getters.getMainBannersData
    })

    const openCloseLoader = (val) => {
      store.commit('SetShowLoaderBanners', val)
    }

    const clearLoadBanners = () => {
      store.dispatch('setClearLoadBanners')
      store.commit('SetShowLoaderBanners', false)
    }

    const saveBanners = () => {
      store.dispatch('setSaveBanners')
      store.commit('SetShowLoaderBanners', false)
    }

    const deleteBanner = (id) => {
      store.dispatch('setDeleteBanner', id)
    }

    const showItems = () => {
      visibleItems.value = !visibleItems.value
    }

    const saveForms = () => {
      store.dispatch('setMoveBanners')
    }

    const closeBannersEditor = () => {
      router.push('/modules')
    }

    const showLoaderBanners = computed(() => store.getters.getShowLoaderBanners)

    const getCurrentBanner = (urlBanner) => {
      currentBanner.value = urlBanner
      currentId.value = urlBanner.Id
      title.value = urlBanner.Header
      description.value = urlBanner.Description
      link.value = urlBanner.Link
    }

    const showDescriptionPrewiew = () => {
      if (title.value !== '' || description.value !== '' || link.value !== '') {
        visibleDescriptionPrewiew.value = true
        currentBanner.value.Header = title.value
        currentBanner.value.Description = description.value
        currentBanner.value.Link = link.value
      } else {
        visibleDescriptionPrewiew.value = false
      }
    }
    const authToken = (e) => {
      e.xhr.setRequestHeader('Authorization', `Bearer ${localStorage.token || sessionStorage.token}`)
    }

    const moveBanners = (evn) => {
      store.commit('SetMoveBanners', evn.moved)
    }

    return {
      bannersData,
      title,
      description,
      link,
      currentId,
      currentBanner,
      envUrlBase,
      getCurrentBanner,
      showDescriptionPrewiew,
      visibleDescriptionPrewiew,
      openCloseLoader,
      clearLoadBanners,
      saveBanners,
      deleteBanner,
      saveForms,
      closeBannersEditor,
      authToken,
      showLoaderBanners,
      visibleItems,
      showItems,
      loaderVideo,
      moveBanners
    }
  }
}
</script>

<style lang="scss" scoped>
.banner {
  display: flex;
  flex-direction: column;
  gap: 10px;

  &__list {
    display: flex;
    align-items: center;

    &-item {
      display: flex;
      gap: 24px;
    }
  }

  &__editor {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;
    text-align: left;
    line-height: 1.8;

    &-item {
      align-self: start;
      width: 100%;
      font-weight: 500;
      font-size: 18px;
    }
  }

  &__preview {
    max-width: 839px;
    height: 208px;
    border-radius: 10px
  }
}
.buttons {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}
.image-uploader {
  display: flex;
  flex-direction: column;
  gap: 25px;
  &:last-child {
    margin-bottom: 104px;
  }

  &__item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 26px;

    :deep(.p-button) {
      background-color: #00ABEC;
      border: none;
      transition: 0.5s;

      &:hover {
        background-color: #0080B0;
        opacity: 0.8;
        transition: 0.5s;
      }
      &:active {
        background-color: #006084;
        opacity: 0.8;
        transition: 0.5s;
      }

      &:focus {
        box-shadow: transparent;
      }
    }

    &-name {
      font-size: 16px;
      font-weight: 400;
    }
  }

  &__buttons {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 24px;
    background-color: #F5F5F5;
    display: flex;
    gap: 12px;
    justify-content: flex-end;
    border-top: 2px solid #D6D6D6;
  }
}
.video-uploader {
  display: flex;
  flex-direction: column;
  gap: 76px;
  padding: 80px 64px 0px 64px;

  :deep(.p-inputtext) {
    width: 420px;
  }

  &__buttons {
    display: flex;
    gap: 30px;
    justify-content: center;
  }
}

.adder {
  display: flex;
  gap: 30px;

  &__items {
    transform: translateX(-350px);
    opacity: 0;
    transition: ease-in 0.5s;

    &_visible {
      opacity: 1;
      transform: translateX(0);
      transition: ease-out 0.5s;
    }
  }
}
:deep(.base-button) {
  width: 200px;
}
:deep(.footer) {
  justify-content: flex-end !important;
}

:deep(.p-inputtext) {
  width: 100%;
  max-width: 839px;
  border: 1px solid #000000;
  // -webkit-box-shadow: inset 0 0 0 50px white;
}

:deep(.p-inputtext:enabled:hover) {
  border-color: #00ABEC;
}
:deep(.p-inputtext:disabled) {
  opacity: 0.5;
}

:deep(.p-inputtext:enabled:focus) {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.1rem #00ABEC;
  border-color: #00ABEC;
  -webkit-box-shadow: inset 0 0 0 50px white;
}
</style>
